import React, { useEffect } from 'react';

import { Editor } from 'slate';
import { ReactEditor, useSlate } from 'slate-react';

import nodeControls from '../../node-menu/control-types';
import BaseElement from '../base';

import HelptapEditor from '../../helpers';
import { determineBaseProperties } from '../utilities';

function Header(props) {

  const editor = useSlate();
  const nodePath = ReactEditor.findPath(editor, props.element);
  const pathReference = Editor.pathRef(editor, nodePath);

  const baseElementProperties = determineBaseProperties({
    ...props,
    customNodeControls: []
  });

  useEffect(function onChildrenChange() {

    if (pathReference.current) {
      HelptapEditor.tableOfContents.update(editor, pathReference.current);
    }

    return function cleanup() {
      pathReference.unref();
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.children, props.element]);

  function renderMain() {

    const attributes = {
      ...props.attributes,
      className: 'editor-element',
      contentEditable: baseElementProperties.contentEditable
    };

    if (props.type === 'heading-six') {

      attributes.className += ' editor-h6';

      return <h6 {...attributes}>{props.children}</h6>;
    }

    if (props.type === 'heading-five') {

      attributes.className += ' editor-h5';

      return <h5 {...attributes}>{props.children}</h5>;
    }

    if (props.type === 'heading-four') {

      attributes.className += ' editor-h4';

      return <h4 {...attributes}>{props.children}</h4>;
    }

    if (props.type === 'heading-three') {

      attributes.className += ' editor-h3';

      return <h3 {...attributes}>{props.children}</h3>;
    }

    if (props.type === 'heading-two') {

      attributes.className += ' editor-h2';

      return <h2 {...attributes}>{props.children}</h2>;
    }

    attributes.className += ' editor-h1';

    return <h1 {...attributes}>{props.children}</h1>;

  }

  return <BaseElement {...baseElementProperties}>
    {renderMain()}
  </BaseElement>;

}

export default Header;